import { render, staticRenderFns } from "./NeedsTable.vue?vue&type=template&id=0e3faa00&scoped=true&"
import script from "./NeedsTable.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedsTable.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3faa00",
  null
  
)

export default component.exports